function n() {
  return typeof navigator > "u" ? !1 : !!(navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && navigator.userAgent.indexOf("CriOS") === -1 && navigator.userAgent.indexOf("FxiOS") === -1);
}
export {
  n as isSafari
};
